module.exports = __webpack_public_path__ + "img/laravel.e3e8a2cb.svg";